import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from '@angular/core';
import { ITaskV2 } from '@fi-app/task-v2/fi-task-v2';
import { Subject } from 'rxjs';
import { FiTaskSyncService } from '@fi-shared/fi-task-shared/fi-task-sync-service';
import { FiTaskStatusType } from '@fi-app/task-v2/fi-task-v2-enums';

@Component({
    selector: 'fi-task-v2-description',
    templateUrl: './task-v2-description.component.html',
    styleUrls: ['./task-v2-description.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-task-v2-description' },
    standalone: false,
})
export class FiTaskV2DescriptionComponent implements OnInit, OnDestroy {
    @Input({ required: true }) task: ITaskV2;
    @Input() isAutomatedTask: boolean;

    constructor(
        private fiTaskSyncService: FiTaskSyncService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        this.subscribeToSyncTasks();
    }
    protected isTaskOverdue(): boolean {
        return this.task.IsDeadlinePassed && this.task.Status !== FiTaskStatusType.Completed;
    }

    private subscribeToSyncTasks() {
        this.fiTaskSyncService.subscribeToTaskUpdatedBySync(this.task.Id, this.ngOnDestroy$, (updatedTask) => {
            this.fiTaskSyncService.updateTaskProps(this.task, updatedTask);
            this.cdr.markForCheck();
        });
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
